function googleTranslateElementInit() {
    new google.translate.TranslateElement({
        pageLanguage: 'en',
        gaTrack: false,
        gaId: ''
    }, 'google_translate_element');
    var removePopup = document.getElementById('goog-gt-tt');
    removePopup.parentNode.removeChild(removePopup);
}

var googleTranslateScript = document.createElement('script');
googleTranslateScript.type = 'text/javascript';
googleTranslateScript.async = false;
googleTranslateScript.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';

(document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(googleTranslateScript);

$(window).load(function () {
    setTimeout(function () {
        $('.goog-te-combo option:first').text("Translate");
    }, 300);
});